<template>
    <div class="license-activation-content">
        <PageHeader :title="$t('pages.licenseActivation.title')"
                    :desc="$t('pages.licenseActivation.desc')">
        </PageHeader>

        <PageFrameContainer>
            <Loader v-if="submitting === true">{{$t('pages.licenseActivation.activating')}} ...</Loader>
            <div v-else class="license-page-container">
                <div class="license-info-form">
                    <label for="device">{{$t('pages.licenseActivation.deviceId')}}</label>
                    <input type="text" id="device" v-model="deviceId"/>
                    <label for="license">{{$t('pages.licenseActivation.licenseId')}}</label>
                    <input type="text" id="license" v-model="licenseId"/>

                    <p>{{response}}</p>
                    <button v-on:click="activate" :disabled="deviceId==null||deviceId.length==0||licenseId==null||licenseId.length==0">{{$t('pages.licenseActivation.activateBtnText')}}</button>
                </div>
            </div>
        </PageFrameContainer>
    </div>
</template>

<script>
    import PageFrameContainer from "../../components/PageFrameContainer";
    import PageHeader from "../../components/PageHeader";
    import Loader from "../../components/Loader";

    export default {
        name: "LicenseActivationPage",
        components: {
            PageHeader,
            PageFrameContainer,
            Loader
        },
        data: function () {
            return {
                deviceId: "",
                licenseId: "",
                response: "",
                submitting: false,

            }
        },
        methods: {
            async activate() {
                this.submitting = true;
                try {
                    let data = await this.$bw1LicenseApi.activateLicense({
                        product: "BW1Player",
                        manual: true,
                        deviceId: this.deviceId,
                        licenseId: this.licenseId
                    });
                    let blob = new Blob([data], {type: "image/png"});
                    let filename = `${this.deviceId}.png`
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var URL = window.URL || window.webkitURL;
                        var downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("a");
                            // safari doesn't support this yet
                            if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }
                    }
                    this.response = `Activation succeed! Activation image was downloaded.`;
                } catch (e) {
                    this.response = `Activation failed: ${e}`
                } finally {
                    this.submitting = false;
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../theme/theme";

    .license-activation-content {
        text-align: justify;
    }

    .license-page-container {
        margin-bottom: 3rem;

        .license-info-form {
            padding-top: 1em;
            display: grid;
            grid-gap: 0.6em;
            align-self: start;
            max-width: 30em;
            margin-left: auto;
            margin-right: auto;

            label {
                color: $text80;
            }

            input {
                padding: 0.2em 0.6em;
                font-size: 1.1rem;
                border-width: 1px;
                border-color: $text40;
                background-color: $back20;
                color: $text100;
                border-style: solid;
                border-radius: 0.3em;
            }

            input:focus {
                border-color: $primary60;
                outline: none;
            }



            button {
                margin-right: 1em;
                padding: 0.7em 2em;
                background: $primary100;
                border-radius: 0.4em;
                border-color: $back20;
                border-width: 1px;
                border-style: solid;
                text-decoration: none;
                text-effect: none;
                font-size: 1em;
                cursor: pointer;
                color: $primaryText100;
                justify-self: right;
                outline: none;
            }

            button:hover {
                background: $primary40;
            }

            button:disabled,
            button[disabled] {
                background: $back60;
            }
        }
    }
</style>